import { Attribute, Component, Input, OnChanges, OnInit } from '@angular/core';
import { TreeModule } from 'primeng/tree';
import { Category } from '../../../import/category.type';
import { CategoryService } from '../../../import/service/category.service';
import { TreeNode } from 'primeng/api';
import { PanelModule } from 'primeng/panel';
import { TagModule } from 'primeng/tag';
import { TableModule } from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { ClipboardModule } from 'ngx-clipboard';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-taxonomy-categories',
  standalone: true,
  imports: [TreeModule, PanelModule, TagModule, TableModule, TranslateModule, ButtonModule, ClipboardModule,
      TooltipModule,],
  templateUrl: './taxonomy-categories.component.html',
  styleUrl: './taxonomy-categories.component.scss',
  providers: [],
})
export class TaxonomyCategoriesComponent implements OnChanges, OnInit {
  @Input() categories: Category[] = [];
  @Input() selectedLocale;

  selectedCategory = null;
  loading: boolean = true;
  selectedNode!: TreeNode;
  attributeSize: number = 0;
  isCollapsed: boolean = true;
  attributes: Attribute[] = [];
  headers = [
    {
      id: 'attribute_label',
      value: 'table.name',
    },
    {
      id: 'mandatory',
      value: 'table.nature',
    },
    {
      id: 'attributeType',
      value: 'table.type',
    },
    {
      id: 'attributeCode',
      value: 'table.TechnicalID',
    },
  ];

  channels;
  showTooltip: boolean = false;

  constructor(private readonly categoryService: CategoryService) {}

  ngOnInit() {
    this.loading = true;
  }

  finishLoading() {
    this.loading = false;
  }

  ngOnChanges(): void {
    this.attributes = [];
    this.isCollapsed = true;
    this.attributeSize = 0;
  }

  onNodeSelected(event) {
    if (event.node.hasChildren == 'false') {
      this.selectedCategory = event.node.categoryId;
      this.categoryService.getAttributesByCategoryId(event.node.categoryId).subscribe({
        next: (res: any) => {
          this.attributes = res.attributes?.map((attr) => ({
            ...attr,
            attribute_label:
              attr.attributeLabel?.find((attrLabel) => attrLabel.locale == this.selectedLocale)?.label ?? 'N/A',
          }));
          this.attributeSize = this.attributes?.length;
          this.isCollapsed = false;
        },
      });
    }
  }


  handleAttributeClick(attribute) {
    console.log(this.selectedCategory)
    console.log(attribute)
  }

  toggleTooltip() {
    this.showTooltip = !this.showTooltip;
  }
}
